import React, { useState } from "react";
import PropTypes from 'prop-types';
import ReactDOM from "react-dom";

import { connect } from 'react-redux';
import {
    MSGOK, recortarCadena, obtenerUsuario, obtenerToken, traducirPagina, convertirCodigoAMeses, dynamicSortAsc, dynamicSortDesc,
    MSGERROR

} from "../librerias/funciones"


import { DashboardHomeEnAPI, abortFetch } from "../action/actionCreatorsRequests";

import {
    ArrowUpOutlined,
    ArrowDownOutlined,
    UpOutlined,
    DownOutlined

} from '@ant-design/icons';

import { Progress, Select } from 'antd';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from "recharts";

import '../styles/home.css'
import { CPAnyosPeriodo } from "./CPAnyosPeriodo";
import { FichaVentaOnline } from "./Home/FichaVentaOnline";
import FichaDetalleMatriculaSocio from "./Home/FichaDetalleMatriculaSocio";

const { Option } = Select;

const Home = ({ props }) => {
    const [registroSocios, setRegistroSocios] = React.useState([]);

    const [evolucionContainer, setEvolucionContainer] = React.useState({ height: 0, width: 0 });
    const ref = React.useRef(null)

    const [abrirDesgloseVentas, setAbrirDesgloseVentas] = React.useState(false);

    const [initFilter, setInitFilter] = React.useState({
        COSNULTA_SELECCIONADA: 0,
        COMPRAS: {},
        MARCAS: [],
        PROVEEDORES: [],
        VENTAS: [],
        ID_SOCIO: null,
        ANYOS: [],
        ACTIVE_MENU: 0,
        COMPRAS_ANYO: { MES: 0, ANYO: 0 },
        MARCAS_ANYO: { MES: 0, ANYO: 0 },
        PROVEEDORES_ANYO: { MES: 0, ANYO: 0 },
        VENTAS_ANYO: { MES: 0, ANYO: 0 },
        EVOLUCION_COMPRA_ANYO: { MES: 0, ANYO: 0 },
        EVOLUCION_COMPRAS: [],
        MATRICULAS: {},
        MATRICULAS_ANYO: { MES: 0, ANYO: 0 },
        REDES_GRUPO: [],
        REDES_GRUPO_ANYO: { MES: 0, ANYO: 0 },
        REDES_EXTERNAS: [],
        REDES_EXTERNAS_ANYO: { MES: 0, ANYO: 0 },
        SERVICIOS_TALLERES: [],
        SERVICIOS_TALLERES_ANYO: { MES: 0, ANYO: 0 },
        MOSTRAR_TABLA: false,
    })




    const [registroKeyGrafico, setRegistroKeyGrafico] = React.useState([

        {
            "NOMBRE": 2021,
            "ACTIVO": true,
            "COLOR": "var(--azul-claro-serca)",
            "ANYO": 2021,
        },
        {
            "NOMBRE": 2022,
            "ACTIVO": true,
            "COLOR": "var(--azul-oscuro-serca)",
            "ANYO": 2022,
        }
    ]);

    const [abriFichaMatricula, setAbriFichaMatricula] = useState(false)



    /*
0 - TOTAL COMPRAS
1 - COMPRAS EVOLUCION (GRAFICO GRANDE) 
2 - TOP MARCAS
3 - TOP PROVEEDORES
4 - VENTAS ONLINE (PEDIDOS)
*/


    const bucarRegistros = async (MES_INI, MES_FIN, ANYO, CONSULTA, ID_SOCIO, ID_PAIS) => {
        let RESULTADOS = null
        let registros = await DashboardHomeEnAPI(MES_INI, MES_FIN, ANYO, CONSULTA, ID_SOCIO, ID_PAIS)
        if (registros !== undefined && registros !== null && registros.REGISTROS !== undefined && registros.REGISTROS !== null) {
            RESULTADOS = registros.REGISTROS;
        }

        return RESULTADOS;
    }

    const obtenerMesPeriodo = (REGISTRO) => {
        return REGISTRO === 0 ? { INICIO: 1, FIN: 12 } : { INICIO: REGISTRO, FIN: REGISTRO }
    }
    /*
        const ObtenerHtml = (cadena) => {
            let RESULTADO = cadena
            cadena = cadena !== undefined && cadena !== null ? cadena : ""
    
            if (cadena.includes("div")) {
                let dom = document.createElement('div');
                dom.innerHTML = cadena;
                let color = dom.children[0].attributes[0] !== undefined ? dom.children[0].attributes[0].value : ""
    
            }
    
            RESULTADO = <div style={{ color: color.split(":")[1] }} className="center_text_table"><> <>{dom.innerText}</> <> {cadena.includes("ArrowUpOutlined") ? <ArrowUpOutlined></ArrowUpOutlined> : cadena.includes("ArrowDownOutlined") ? <ArrowDownOutlined></ArrowDownOutlined> : null}</> </> </div>
    
            return RESULTADO
        }
    */


    const ObtenerTexto = (cadena) => {
        let RESULTADO = cadena
        cadena = cadena !== undefined && cadena !== null ? cadena : ""
        if (cadena !== "") {
            let IMPORTE = cadena.includes("-") ? false : true
            RESULTADO = <div style={{ color: IMPORTE ? 'green' : 'red' }} ><> <>{cadena}</> <> {IMPORTE ? <ArrowUpOutlined></ArrowUpOutlined> : <ArrowDownOutlined></ArrowDownOutlined>}</> </> </div>

        }

        return RESULTADO
    }

    const seleccionadoActual = (registros) => {
        let REGISTRO = registros.find((registro) => registro.SELECCIONADO)
        return REGISTRO === undefined ? { ID: null, DESCRIPCION: null } : REGISTRO
    }

    const anyoActual = (REGISTROS) => {
        const { ID_COMPONENTE } = REGISTROS
        const ANYO_ACTUAL = seleccionadoActual(REGISTROS.ANYOS).ID

        //actualizarAnyoGrafico()

        switch (ID_COMPONENTE) {
            case 1:
                const PERIODO = obtenerMesPeriodo(initFilter.COMPRAS_ANYO.MES)

                initFilter.COMPRAS = {}
                initFilter.COMPRAS_ANYO.ANYO = ANYO_ACTUAL
                setInitFilter({ ...initFilter })
                bucarRegistros(PERIODO.INICIO, PERIODO.FIN, initFilter.COMPRAS_ANYO.ANYO, 0, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.COMPRAS = registros === null ? null : registros[0]
                    setInitFilter({ ...initFilter })
                })
                break;
            case 2:
                const PERIODO_MARCA = obtenerMesPeriodo(initFilter.MARCAS_ANYO.MES)

                //MARCAS 2
                initFilter.MARCAS = []
                initFilter.MARCAS_ANYO.ANYO = ANYO_ACTUAL
                setInitFilter({ ...initFilter })
                bucarRegistros(PERIODO_MARCA.INICIO, PERIODO_MARCA.FIN, initFilter.MARCAS_ANYO.ANYO, 2, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.MARCAS = registros
                    setInitFilter({ ...initFilter })

                })
                break;
            case 3:
                const PERIODO_PROV = obtenerMesPeriodo(initFilter.PROVEEDORES_ANYO.MES)

                //PROVEEDORES 3
                initFilter.PROVEEDORES = []
                initFilter.PROVEEDORES_ANYO.ANYO = ANYO_ACTUAL
                setInitFilter({ ...initFilter })

                bucarRegistros(PERIODO_PROV.INICIO, PERIODO_PROV.FIN, initFilter.PROVEEDORES_ANYO.ANYO, 3, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.PROVEEDORES = registros
                    setInitFilter({ ...initFilter })
                })
                break;

            case 4:
                const PERIODO_SERVICIO_TALLERES = obtenerMesPeriodo(initFilter.SERVICIOS_TALLERES_ANYO.MES)

                //SERVICIOS TALLERES 10
                initFilter.SERVICIOS_TALLERES = []
                initFilter.SERVICIOS_TALLERES_ANYO.ANYO = ANYO_ACTUAL
                setInitFilter({ ...initFilter })

                bucarRegistros(PERIODO_SERVICIO_TALLERES.INICIO, PERIODO_SERVICIO_TALLERES.FIN, initFilter.SERVICIOS_TALLERES_ANYO.ANYO, 10, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.SERVICIOS_TALLERES = registros
                    setInitFilter({ ...initFilter })
                })
                break;

            case 5:
                const PERIODO_REDES_EXTERNAS = obtenerMesPeriodo(initFilter.REDES_EXTERNAS_ANYO.MES)

                initFilter.REDES_EXTERNAS = []
                initFilter.REDES_EXTERNAS_ANYO.ANYO = ANYO_ACTUAL
                setInitFilter({ ...initFilter })

                //REDES EXTERNAS 8
                bucarRegistros(PERIODO_REDES_EXTERNAS.INICIO, PERIODO_REDES_EXTERNAS.FIN, initFilter.REDES_EXTERNAS_ANYO.ANYO, 8, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.REDES_EXTERNAS = registros
                    setInitFilter({ ...initFilter })

                })
                break;

            case 6:
                const PERIODO_REDES_GRUPO = obtenerMesPeriodo(initFilter.REDES_GRUPO_ANYO.MES)

                initFilter.REDES_GRUPO = []
                initFilter.REDES_GRUPO_ANYO.ANYO = ANYO_ACTUAL
                setInitFilter({ ...initFilter })

                //REDES GRUPO 9
                bucarRegistros(PERIODO_REDES_GRUPO.INICIO, PERIODO_REDES_GRUPO.FIN, initFilter.REDES_GRUPO_ANYO.ANYO, 9, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.REDES_GRUPO = registros
                    setInitFilter({ ...initFilter })
                })
                break;

            case 7:
                const PERIODO_MATRICULAS = obtenerMesPeriodo(initFilter.MATRICULAS_ANYO.MES)

                //PROVEEDORES 3
                initFilter.MATRICULAS = {}
                initFilter.MATRICULAS_ANYO.ANYO = ANYO_ACTUAL
                setInitFilter({ ...initFilter })

                bucarRegistros(PERIODO_MATRICULAS.INICIO, PERIODO_MATRICULAS.FIN, initFilter.MATRICULAS_ANYO.ANYO, 6, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.MATRICULAS = registros === null ? null : registros[0]
                    setInitFilter({ ...initFilter })
                })
                break;

            case 8:
                const PERIODO_VENTAS = obtenerMesPeriodo(initFilter.VENTAS_ANYO.MES)
                //VENTAS ONLINE 8
                initFilter.VENTAS = []
                initFilter.VENTAS_ANYO.ANYO = ANYO_ACTUAL
                setInitFilter({ ...initFilter })

                bucarRegistros(PERIODO_VENTAS.INICIO, PERIODO_VENTAS.FIN, initFilter.VENTAS_ANYO.ANYO, 4, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.VENTAS = registros
                    setInitFilter({ ...initFilter })
                })
                break;

            case 9:
                const PERIODO_EVO_COMPRAS = obtenerMesPeriodo(initFilter.EVOLUCION_COMPRA_ANYO.MES)
                //EVOLUCION COMPRAS 9
                initFilter.EVOLUCION_COMPRAS = []
                initFilter.EVOLUCION_COMPRA_ANYO.ANYO = ANYO_ACTUAL

                setInitFilter({ ...initFilter })

                bucarRegistros(PERIODO_EVO_COMPRAS.INICIO, PERIODO_EVO_COMPRAS.FIN, initFilter.EVOLUCION_COMPRA_ANYO.ANYO, 1, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.EVOLUCION_COMPRAS = registros
                    setInitFilter({ ...initFilter })
                })



                registroKeyGrafico[0].NOMBRE = initFilter.EVOLUCION_COMPRA_ANYO.ANYO - 1
                registroKeyGrafico[0].ANYO = initFilter.EVOLUCION_COMPRA_ANYO.ANYO - 1
                registroKeyGrafico[1].NOMBRE = initFilter.EVOLUCION_COMPRA_ANYO.ANYO
                registroKeyGrafico[1].ANYO = initFilter.EVOLUCION_COMPRA_ANYO.ANYO

                setRegistroKeyGrafico([...registroKeyGrafico])

                break;
        }
    }


    const periodoMes = (REGISTROS) => {
        const { ID_COMPONENTE } = REGISTROS
        const MES_ACTUAL = seleccionadoActual(REGISTROS.INICIAL_MES).ID
        const { INICIO, FIN } = obtenerMesPeriodo(MES_ACTUAL)

        switch (ID_COMPONENTE) {
            case 1:
                initFilter.COMPRAS = {}
                initFilter.COMPRAS_ANYO.MES = MES_ACTUAL
                setInitFilter({ ...initFilter })
                bucarRegistros(INICIO, FIN, initFilter.COMPRAS_ANYO.ANYO, 0, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.COMPRAS = registros === null ? null : registros[0]
                    setInitFilter({ ...initFilter })
                })
                break;
            case 2:

                //MARCAS 2
                initFilter.MARCAS = []
                initFilter.MARCAS_ANYO.MES = MES_ACTUAL
                setInitFilter({ ...initFilter })
                bucarRegistros(INICIO, FIN, initFilter.MARCAS_ANYO.ANYO, 2, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.MARCAS = registros
                    setInitFilter({ ...initFilter })

                })
                break;
            case 3:
                //PROVEEDORES 3
                initFilter.PROVEEDORES = []
                initFilter.PROVEEDORES_ANYO.MES = MES_ACTUAL
                setInitFilter({ ...initFilter })

                bucarRegistros(INICIO, FIN, initFilter.PROVEEDORES_ANYO.ANYO, 3, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.PROVEEDORES = registros
                    setInitFilter({ ...initFilter })
                })
                break;


            case 4:

                //SERVICIOS TALLERES 10
                initFilter.SERVICIOS_TALLERES = []
                initFilter.SERVICIOS_TALLERES_ANYO.MES = MES_ACTUAL
                setInitFilter({ ...initFilter })

                bucarRegistros(INICIO, FIN, initFilter.SERVICIOS_TALLERES_ANYO.ANYO, 10, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.SERVICIOS_TALLERES = registros
                    setInitFilter({ ...initFilter })
                })
                break;

            case 5:

                initFilter.REDES_EXTERNAS = []
                initFilter.REDES_EXTERNAS_ANYO.MES = MES_ACTUAL
                setInitFilter({ ...initFilter })

                //REDES EXTERNAS 8
                bucarRegistros(INICIO, FIN, initFilter.REDES_EXTERNAS_ANYO.ANYO, 8, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.REDES_EXTERNAS = registros
                    setInitFilter({ ...initFilter })

                })
                break;

            case 6:
                initFilter.REDES_GRUPO = []
                initFilter.REDES_GRUPO_ANYO.MES = MES_ACTUAL
                setInitFilter({ ...initFilter })

                //REDES GRUPO 9
                bucarRegistros(INICIO, FIN, initFilter.REDES_GRUPO_ANYO.ANYO, 9, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.REDES_GRUPO = registros
                    setInitFilter({ ...initFilter })

                })
                break;

            case 7:
                //MATRICULAS
                initFilter.MATRICULAS = {}
                initFilter.MATRICULAS_ANYO.MES = MES_ACTUAL
                setInitFilter({ ...initFilter })

                bucarRegistros(INICIO, FIN, initFilter.MATRICULAS_ANYO.ANYO, 6, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.MATRICULAS = registros === null ? null : registros[0]
                    setInitFilter({ ...initFilter })
                })
                break;
            case 8:
                //VENTAS ONLINE 8
                initFilter.VENTAS = []
                initFilter.VENTAS_ANYO.MES = MES_ACTUAL
                setInitFilter({ ...initFilter })

                bucarRegistros(INICIO, FIN, initFilter.VENTAS_ANYO.ANYO, 4, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.VENTAS = registros
                    setInitFilter({ ...initFilter })
                })
                break;
            case 9:
                //EVOLUCION COMPRAS 9
                initFilter.EVOLUCION_COMPRAS = []
                initFilter.EVOLUCION_COMPRA_ANYO.MES = MES_ACTUAL
                setInitFilter({ ...initFilter })

                bucarRegistros(INICIO, FIN, initFilter.EVOLUCION_COMPRA_ANYO.ANYO, 1, initFilter.ID_SOCIO, null).then((registros) => {
                    initFilter.EVOLUCION_COMPRAS = registros
                    setInitFilter({ ...initFilter })
                })
                break;
        }
    }




    const obtenerEstadisticaEjercicioGrafico = (registros, FORMATEAR_PRECIO, LISTA_ANYOS) => {
        console.log("Entrada",registros, FORMATEAR_PRECIO, LISTA_ANYOS)
        let ANYOS = LISTA_ANYOS;

        let grafico = [];
        registros.map((item, i) => {
            let BUSCAR_MES = grafico.find((registro, i) => registro.MES_NO == item.MES)
            if (BUSCAR_MES === undefined) {
                grafico.push({
                    "MES": item.MES_DESCRIPCION,
                    "MES_NO": item.MES,
                })
            }
        });

        grafico.map((registro, i) => {
            let cambio = registros.filter((item, i) => item.MES === registro.MES_NO);
            ANYOS.map((registro_anyo) => {
                let ANYO_FALTANTE = cambio.find((lista) => lista.ANYO == registro);
                if (ANYO_FALTANTE === undefined) {
                    registro[`${registro_anyo}`] = 0;
                }
            })

            cambio.map((lista) => {
                registro[`${lista.ANYO}`] = FORMATEAR_PRECIO ? parseInt(lista.IMPORTE.replace(",", ".")) :
                    new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(lista.IMPORTE.replace(",", "."));

            })
        })

        console.log("Salida",grafico)
        return grafico;
    }


    const ordenarRegistroTabla = (registros) => {
        let NUEVA_LISTA = [];
        NUEVA_LISTA = registros.filter((registro) => registro !== "MES" && registro !== "MES_NO")
        return NUEVA_LISTA;
    }


    React.useEffect(() => {
        if (ref.current !== null) {
            evolucionContainer.height = ref.current.clientHeight
            evolucionContainer.width = ref.current.clientWidth
            if (evolucionContainer.height !== ref.current.clientHeight || evolucionContainer.width !== ref.current.clientWidth) {
                setEvolucionContainer({ ...evolucionContainer })
            }
        }
    })



    React.useEffect(() => {
        if (obtenerToken() !== undefined) {
            const fecha = new Date();
            const MES_ACTUAL = fecha.getMonth() + 1;
            const { INICIO, FIN } = obtenerMesPeriodo(MES_ACTUAL)


            const { SOCIOS, ANYO_MAXIMO, ANYO_SEL } = obtenerUsuario();
            let ANYO_SELECCIONADO = parseInt(ANYO_SEL)

            let condicion = SOCIOS !== undefined && SOCIOS !== null && SOCIOS.length > 1
            if (condicion) {
                initFilter.ID_SOCIO = null
                setRegistroSocios(SOCIOS)
            } else {
                initFilter.ID_SOCIO = SOCIOS[0].ID_SOCIO
            }





            initFilter.COMPRAS_ANYO.ANYO = ANYO_SELECCIONADO
            initFilter.MARCAS_ANYO.ANYO = ANYO_SELECCIONADO
            initFilter.PROVEEDORES_ANYO.ANYO = ANYO_SELECCIONADO
            initFilter.VENTAS_ANYO.ANYO = ANYO_SELECCIONADO
            initFilter.EVOLUCION_COMPRA_ANYO.ANYO = ANYO_SELECCIONADO
            initFilter.MATRICULAS_ANYO.ANYO = ANYO_SELECCIONADO

            initFilter.REDES_GRUPO_ANYO.ANYO = ANYO_SELECCIONADO
            initFilter.REDES_GRUPO_ANYO.MES = INICIO

            initFilter.REDES_EXTERNAS_ANYO.ANYO = ANYO_SELECCIONADO
            initFilter.REDES_EXTERNAS_ANYO.MES = INICIO

            initFilter.SERVICIOS_TALLERES_ANYO.ANYO = ANYO_SELECCIONADO
            initFilter.SERVICIOS_TALLERES_ANYO.MES = INICIO

            setInitFilter({ ...initFilter })



            registroKeyGrafico[0].NOMBRE = initFilter.EVOLUCION_COMPRA_ANYO.ANYO - 1
            registroKeyGrafico[0].ANYO = initFilter.EVOLUCION_COMPRA_ANYO.ANYO - 1
            registroKeyGrafico[1].NOMBRE = initFilter.EVOLUCION_COMPRA_ANYO.ANYO
            registroKeyGrafico[1].ANYO = initFilter.EVOLUCION_COMPRA_ANYO.ANYO

            setRegistroKeyGrafico([...registroKeyGrafico])


            //DashboardEnAPI
            //COMPRAS 0
            bucarRegistros(1, 12, initFilter.COMPRAS_ANYO.ANYO, 0, initFilter.ID_SOCIO, null).then((registros) => {
                initFilter.COMPRAS = registros === null ? null : registros[0]
                setInitFilter({ ...initFilter })

            })

            //EVOLUCION COMPRAS 1
            bucarRegistros(1, 12, initFilter.EVOLUCION_COMPRA_ANYO.ANYO, 1, initFilter.ID_SOCIO, null).then((registros) => {

                initFilter.EVOLUCION_COMPRAS = registros
                setInitFilter({ ...initFilter })


            })


            //MARCAS 2
            bucarRegistros(1, 12, initFilter.MARCAS_ANYO.ANYO, 2, initFilter.ID_SOCIO, null).then((registros) => {
                initFilter.MARCAS = registros
                setInitFilter({ ...initFilter })

            })

            //PROVEEDORES 3
            bucarRegistros(1, 12, initFilter.PROVEEDORES_ANYO.ANYO, 3, initFilter.ID_SOCIO, null).then((registros) => {
                initFilter.PROVEEDORES = registros
                setInitFilter({ ...initFilter })

            })

            //VENTAS ONLINE 4
            bucarRegistros(1, 12, initFilter.VENTAS_ANYO.ANYO, 4, initFilter.ID_SOCIO, null).then((registros) => {
                initFilter.VENTAS = registros
                setInitFilter({ ...initFilter })

            })


            //MATRICULAS 6
            bucarRegistros(1, 12, initFilter.MATRICULAS_ANYO.ANYO, 6, initFilter.ID_SOCIO, null).then((registros) => {
                initFilter.MATRICULAS = registros === null ? null : registros[0]
                setInitFilter({ ...initFilter })

            })


            //REDES EXTERNAS 8
            bucarRegistros(INICIO, FIN, initFilter.REDES_EXTERNAS_ANYO.ANYO, 8, initFilter.ID_SOCIO, null).then((registros) => {
                initFilter.REDES_EXTERNAS = registros
                setInitFilter({ ...initFilter })

            })

            //REDES GRUPO 9
            bucarRegistros(INICIO, FIN, initFilter.REDES_GRUPO_ANYO.ANYO, 9, initFilter.ID_SOCIO, null).then((registros) => {
                initFilter.REDES_GRUPO = registros
                setInitFilter({ ...initFilter })

            })

            //SERVICIOS_TALLERES 10
            bucarRegistros(INICIO, FIN, initFilter.SERVICIOS_TALLERES_ANYO.ANYO, 10, initFilter.ID_SOCIO, null).then((registros) => {
                initFilter.SERVICIOS_TALLERES = registros
                setInitFilter({ ...initFilter })

            })






        }
    }, [])



    const actualizarVista = (initFilter) => {
        //DashboardEnAPI
        const MES_COMPRA = obtenerMesPeriodo(initFilter.COMPRAS_ANYO.MES)
        const MES_MARCA = obtenerMesPeriodo(initFilter.MARCAS_ANYO.MES)
        const MES_PROV = obtenerMesPeriodo(initFilter.PROVEEDORES_ANYO.MES)
        const MES_VENTAS = obtenerMesPeriodo(initFilter.VENTAS_ANYO.MES)
        const MES_EVO_COMPRAS = obtenerMesPeriodo(initFilter.EVOLUCION_COMPRA_ANYO.MES)
        const MES_MATRICULAS = obtenerMesPeriodo(initFilter.MATRICULAS_ANYO.MES)
        const MES_REDES_GRUPO = obtenerMesPeriodo(initFilter.REDES_GRUPO_ANYO.MES)
        const MES_REDES_EXTERNAS = obtenerMesPeriodo(initFilter.REDES_EXTERNAS_ANYO.MES)
        const MES_SERVICIO_TALLERES = obtenerMesPeriodo(initFilter.SERVICIOS_TALLERES_ANYO.MES)



        initFilter.COMPRAS = {}
        initFilter.MARCAS = []
        initFilter.PROVEEDORES = []
        initFilter.VENTAS = []
        initFilter.EVOLUCION_COMPRAS = []
        initFilter.MATRICULAS = {}
        initFilter.REDES_GRUPO = []
        initFilter.REDES_EXTERNAS = []
        initFilter.SERVICIOS_TALLERES = []





        setInitFilter({ ...initFilter })



        //COMPRAS 0
        bucarRegistros(MES_COMPRA.INICIO, MES_COMPRA.FIN, initFilter.COMPRAS_ANYO.ANYO, 0, initFilter.ID_SOCIO, null).then((registros) => {
            initFilter.COMPRAS = registros === null ? null : registros[0]
            setInitFilter({ ...initFilter })

        })


        //COMPRAS EVOLUCION 1
        bucarRegistros(MES_EVO_COMPRAS.INICIO, MES_EVO_COMPRAS.FIN, initFilter.EVOLUCION_COMPRA_ANYO.ANYO, 1, initFilter.ID_SOCIO, null).then((registros) => {
            initFilter.EVOLUCION_COMPRAS = registros
            setInitFilter({ ...initFilter })

        })

        //MARCAS 2
        bucarRegistros(MES_MARCA.INICIO, MES_MARCA.FIN, initFilter.MARCAS_ANYO.ANYO, 2, initFilter.ID_SOCIO, null).then((registros) => {
            initFilter.MARCAS = registros
            setInitFilter({ ...initFilter })

        })

        //PROVEEDORES 3
        bucarRegistros(MES_PROV.INICIO, MES_PROV.FIN, initFilter.PROVEEDORES_ANYO.ANYO, 3, initFilter.ID_SOCIO, null).then((registros) => {
            initFilter.PROVEEDORES = registros
            setInitFilter({ ...initFilter })

        })


        //VENTAS ONLINE 4
        bucarRegistros(MES_VENTAS.INICIO, MES_VENTAS.FIN, initFilter.VENTAS_ANYO.ANYO, 4, initFilter.ID_SOCIO, null).then((registros) => {
            initFilter.VENTAS = registros
            setInitFilter({ ...initFilter })

        })

        //MATRICULAS 6
        bucarRegistros(MES_MATRICULAS.INICIO, MES_MATRICULAS.FIN, initFilter.MATRICULAS_ANYO.ANYO, 6, initFilter.ID_SOCIO, null).then((registros) => {
            initFilter.MATRICULAS = registros === null ? null : registros[0]
            setInitFilter({ ...initFilter })

        })

        //REDES EXTERNAS 8

        bucarRegistros(MES_REDES_EXTERNAS.INICIO, MES_REDES_EXTERNAS.FIN, initFilter.REDES_EXTERNAS_ANYO.ANYO, 8, initFilter.ID_SOCIO, null).then((registros) => {
            initFilter.REDES_EXTERNAS = registros
            setInitFilter({ ...initFilter })

        })


        //REDES GRUPO 9
        bucarRegistros(MES_REDES_GRUPO.INICIO, MES_REDES_GRUPO.FIN, initFilter.REDES_GRUPO_ANYO.ANYO, 9, initFilter.ID_SOCIO, null).then((registros) => {
            initFilter.REDES_GRUPO = registros
            setInitFilter({ ...initFilter })

        })

        //SERVICIOS_TALLERES 10
        bucarRegistros(MES_SERVICIO_TALLERES.INICIO, MES_SERVICIO_TALLERES.FIN, initFilter.SERVICIOS_TALLERES_ANYO.ANYO, 10, initFilter.ID_SOCIO, null).then((registros) => {
            initFilter.SERVICIOS_TALLERES = registros
            setInitFilter({ ...initFilter })

        })


    }



    const dimensionContainer = (ID) => {
        let DATOS = { ALTO: 0, ANCHO: 0 }
        let myDiv = document.getElementById(ID);
        if (myDiv !== undefined && myDiv !== null) {
            DATOS.ALTO = myDiv.clientHeight - 40;
            DATOS.ANCHO = myDiv.clientWidth - 40;
        }
        return DATOS;
    }



    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>  {traducirPagina("txtDashborad_principal").toUpperCase()}</div>
                <div>
                    {
                        registroSocios !== null && registroSocios.length > 0 ?
                            <Select
                                showSearch
                                allowClear={true}
                                value={initFilter.ID_SOCIO === null || initFilter.ID_SOCIO === 0 ? traducirPagina("Seleccione_socio") : initFilter.ID_SOCIO}
                                style={{ width: '280px' }}
                                className="select_consumo"
                                size="large"
                                placeholder={traducirPagina("Seleccione_socio")}
                                onChange={(e) => {
                                    let registroSeleccionado = e === undefined || e === null ? null : e
                                    initFilter.ID_SOCIO = registroSeleccionado
                                    setInitFilter({ ...initFilter })

                                    actualizarVista(initFilter)
                                    //  ObtenerConsumos(seleccionadoActual(initFilter.FILTRO1).ID, seleccionadoActual(initFilter.FILTRO2).ID, initFilter.ENTRE_MESES.DESDE, initFilter.ENTRE_MESES.HASTA, seleccionadoActual(initFilter.PERIODO).DESCRIPCION, seleccionadoActual(initFilter.PAISES).ID, initFilter.ID_SOCIO)
                                }}
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {registroSocios.length > 0 ?
                                    registroSocios.map((registro) =>
                                        <Option key={registro.ID_SOCIO} value={registro.ID_SOCIO}>{registro.NOMBRE_SOCIO}</Option>
                                    )
                                    :
                                    null
                                }
                            </Select>
                            :
                            null

                    }
                </div>
            </div>
        </>,
        document.getElementById("tituloMenu")
    );

    const { COMPRAS,
        MARCAS,
        PROVEEDORES,
        VENTAS,
        COMPRAS_ANYO,
        MARCAS_ANYO,
        PROVEEDORES_ANYO,
        VENTAS_ANYO,
        EVOLUCION_COMPRA_ANYO,
        MATRICULAS,
        REDES_GRUPO,
        REDES_EXTERNAS,
        SERVICIOS_TALLERES,
        EVOLUCION_COMPRAS,
        MOSTRAR_TABLA
    } = initFilter


    const { ANCHO, ALTO } = dimensionContainer("evol_compra")

    /*
        if (ref.current !== null) {
            evolucionContainer.height = ref.current.clientHeight
            evolucionContainer.width = ref.current.clientWidth
    
            if(evolucionContainer.height !== ref.current.clientHeight || evolucionContainer.width !== ref.current.clientWidth){
                setEvolucionContainer({...evolucionContainer})
    
            }
    
        }
        */

    return (
        <>
            <div className="LayoutGraficos">
                <div className="container_graficos1">

                    <div className={`graficos1_child1 ${COMPRAS !== null && Object.keys(COMPRAS).length > 0 ? "desactivar_loader" : "activar_loader"}`} style={{ minHeight: '260px' }} >
                        <div className="titulo_card"> Compras </div>
                        <div className="body_grafico">
                            {
                                COMPRAS === null ?
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '10vh', width: '100%' }}> <h3 style={{ margin: 0 }}>{traducirPagina("Sin_resultados")}</h3> </div>
                                    :
                                    Object.keys(COMPRAS).length > 0 ?

                                        <table className="grafico_registros">
                                            <thead>
                                                <tr>
                                                    <th></th>

                                                    <th style={{ width: "140px" }} >{(COMPRAS_ANYO.ANYO - 1)}</th>
                                                    <th style={{ width: "140px" }} className="margen_unico">{COMPRAS_ANYO.ANYO}</th>
                                                    <th style={{ width: "90px" }} className="margen_unico">INC</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="txt_inicial_tabla">Grupo</td>
                                                    <td >{COMPRAS.TOTAL_GRUPO_ANTERIOR}</td>
                                                    <td className="margen_unico">{COMPRAS.TOTAL_GRUPO_ACTUAL}</td>
                                                    <td className="margen_unico">{ObtenerTexto(COMPRAS.INCREMENTO_GRUPO)}</td>

                                                </tr>
                                                <tr>
                                                    <td className="txt_inicial_tabla">País</td>
                                                    <td >{COMPRAS.TOTAL_PAIS_ANTERIOR}</td>
                                                    <td className="margen_unico">{COMPRAS.TOTAL_PAIS_ACTUAL}</td>
                                                    <td className="margen_unico">{ObtenerTexto(COMPRAS.INCREMENTO_PAIS)}</td>

                                                </tr>
                                                <tr>
                                                    <td className="txt_inicial_tabla">Mis compras</td>
                                                    <td>{COMPRAS.TOTAL_SOCIO_ANTERIOR}</td>
                                                    <td className="margen_unico">{COMPRAS.TOTAL_SOCIO_ACTUAL}</td>
                                                    <td className="margen_unico">{ObtenerTexto(COMPRAS.INCREMENTO_SOCIO)}</td>

                                                </tr>

                                            </tbody>
                                        </table>
                                        :
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '10vh', width: '100%' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                            }
                        </div>

                        <div className="footer_graficos">
                            <div>
                                <button>{traducirPagina("Evolucion")}</button>
                            </div>
                            <div>
                                <CPAnyosPeriodo ID={1} MES_SELECCIONADO={periodoMes} ANYO_SELECCIONADO={anyoActual} ></CPAnyosPeriodo>
                            </div>

                        </div>
                    </div>

                    <div className={`graficos1_child2 ${MARCAS !== null && MARCAS.length > 0 ? "desactivar_loader" : "activar_loader"}`} style={{ minHeight: '320px' }}>

                        <div className="titulo_card"> Marcas TOP 5 </div>
                        <div className="body_grafico">

                            {MARCAS === null ?
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '20vh', width: '100%' }}> <h3 style={{ margin: 0 }}>{traducirPagina("Sin_resultados")}</h3> </div>
                                :
                                MARCAS.length > 0 ?
                                    <table className="grafico_registros">
                                        <thead>
                                            <tr>
                                                <th></th>

                                                <th style={{ width: "140px" }} >{(MARCAS_ANYO.ANYO - 1)}</th>
                                                <th style={{ width: "140px" }} className="margen_unico">{MARCAS_ANYO.ANYO}</th>
                                                <th style={{ width: "90px" }} className="margen_unico">INC</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                MARCAS.map((registro) =>

                                                    <tr>
                                                        <td className="txt_inicial_tabla">{registro.MARCA}</td>
                                                        <td>{registro.IMPORTE_ANTERIOR}</td>
                                                        <td className="margen_unico">{registro.IMPORTE}</td>
                                                        <td className="margen_unico">{ObtenerTexto(registro.INCREMENTO)}</td>
                                                    </tr>
                                                )
                                            }

                                        </tbody>
                                    </table>
                                    :
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '20vh', width: '100%' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                            }
                        </div>
                        <div className="footer_graficos">
                            <div>
                                <button>{traducirPagina("Evolucion")}</button>
                            </div>
                            <div>
                                <CPAnyosPeriodo ID={2} MES_SELECCIONADO={periodoMes} ANYO_SELECCIONADO={anyoActual}></CPAnyosPeriodo>

                            </div>

                        </div>
                    </div>

                    <div className={`graficos1_child3 ${PROVEEDORES !== null && PROVEEDORES.length > 0 ? "desactivar_loader" : "activar_loader"}`} style={{ minHeight: '320px' }}>

                        <div className="titulo_card"> Proveedores TOP 5 </div>
                        <div className="body_grafico">
                            {PROVEEDORES === null ?
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '10vh', width: '100%' }}> <h3 style={{ margin: 0 }}>{traducirPagina("Sin_resultados")}</h3> </div>
                                :
                                PROVEEDORES.length > 0 ?
                                    <table className="grafico_registros">
                                        <thead>
                                            <tr>
                                                <th></th>

                                                <th style={{ width: "140px" }} >{PROVEEDORES_ANYO.ANYO - 1}</th>
                                                <th style={{ width: "140px" }} className="margen_unico">{PROVEEDORES_ANYO.ANYO}</th>
                                                <th style={{ width: "90px" }} className="margen_unico">INC</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                PROVEEDORES.map((registro) =>
                                                    <tr>
                                                        <td className="txt_inicial_tabla">{registro.PROVEEDOR}</td>
                                                        <td>{registro.IMPORTE_ANTERIOR}</td>
                                                        <td className="margen_unico">{registro.IMPORTE}</td>
                                                        <td className="margen_unico">{ObtenerTexto(registro.INCREMENTO)}</td>
                                                    </tr>
                                                )
                                            }

                                        </tbody>
                                    </table>
                                    :
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '10vh', width: '100%' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                            }
                        </div>
                        <div className="footer_graficos">
                            <div>
                                <button>{traducirPagina("Evolucion")}</button>
                            </div>
                            <div>
                                <CPAnyosPeriodo ID={3} MES_SELECCIONADO={periodoMes} ANYO_SELECCIONADO={anyoActual} ></CPAnyosPeriodo>
                            </div>

                        </div>

                    </div>

                </div>

                <div className="container_graficos2">

                    <div className={`graficos2_child1 ${SERVICIOS_TALLERES !== null && SERVICIOS_TALLERES.length > 0 ? "desactivar_loader" : "activar_loader"}`}>
                        <div className="titulo_card"> Servicios talleres </div>
                        <div className="body_grafico container_servicio" style={{ minHeight: '220px' }}>

                            {
                                SERVICIOS_TALLERES === null ?
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}> <h3 style={{ margin: 0 }}>{traducirPagina("Sin_resultados")}</h3> </div>
                                    :
                                    SERVICIOS_TALLERES.length > 0 ?
                                        SERVICIOS_TALLERES.map((registro, i) =>

                                            <div className={SERVICIOS_TALLERES.length - 1 > i ? `servicio_separador` : ""} >
                                                <div className="titulo_servicio">{registro.NOMBRE}</div>

                                                <div className="body_servicio">
                                                    <div className="servicio_info">Grupo <span>{registro.TALLERES_GRUPO}	</span></div>
                                                    <div className="servicio_info">Socio <span>{registro.TALLERES_SOCIO}</span></div>
                                                </div>


                                                <div className="center_porcentaje">
                                                    <Progress type="circle" percent={registro.CIENTO_TOTAL.replace(",", ".")} strokeColor='var(--azul-claro-serca)' width={100} />
                                                </div>
                                            </div>
                                        )
                                        :
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                            }

                        </div>

                        <div className="footer_graficos">
                            <div>
                                <button>{traducirPagina("Evolucion")}</button>
                            </div>
                            <div>
                                <CPAnyosPeriodo ID={4} MES_SELECCIONADO={periodoMes} ANYO_SELECCIONADO={anyoActual} ></CPAnyosPeriodo>
                            </div>
                        </div>
                    </div>


                    <div className={`graficos2_child2 ${REDES_EXTERNAS !== null && REDES_EXTERNAS.length > 0 ? "desactivar_loader" : "activar_loader"}`}>
                        <div className="titulo_card"> Consumo redes externas </div>
                        <div className="body_grafico container_servicio" style={{ minHeight: '220px' }}>
                            {
                                REDES_EXTERNAS === null ?
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}> <h3 style={{ margin: 0 }}>{traducirPagina("Sin_resultados")}</h3> </div>
                                    :
                                    REDES_EXTERNAS.length > 0 ?
                                        REDES_EXTERNAS.map((registro, i) =>

                                            <div className={REDES_EXTERNAS.length - 1 > i ? `servicio_separador` : ""} >
                                                <div className="titulo_servicio">{registro.NOMBRE}</div>

                                                <div className="body_servicio">
                                                    <div className="servicio_info">Grupo <span>{registro.CONSUMO_GRUPO}	</span></div>
                                                    <div className="servicio_info">Socio <span>{registro.CONSUMO_SOCIO}</span></div>
                                                </div>


                                                <div className="center_porcentaje">
                                                    <Progress type="circle" percent={registro.CIENTO_TOTAL.replace(",", ".")} strokeColor='var(--azul-claro-serca)' width={100} />
                                                </div>
                                            </div>


                                        )


                                        :
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                            }
                        </div>

                        <div className="footer_graficos">
                            <div>
                                <button>{traducirPagina("Evolucion")}</button>

                            </div>
                            <div>
                                <CPAnyosPeriodo ID={5} MES_SELECCIONADO={periodoMes} ANYO_SELECCIONADO={anyoActual} ></CPAnyosPeriodo>
                            </div>
                        </div>
                    </div>


                    <div className={`graficos2_child3 ${EVOLUCION_COMPRAS !== null && EVOLUCION_COMPRAS.length > 0 ? "desactivar_loader" : "activar_loader"}`}>
                        <div className="titulo_card"> Evolución compras </div>

                        <div id="evol_compra" className="body_grafico" ref={ref} style={{ minHeight: '240px' }}>

                            {EVOLUCION_COMPRAS === null ?
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                :

                                EVOLUCION_COMPRAS.length > 0 ?
                                    MOSTRAR_TABLA ?
                                        <div className="max_tabla_compras">
                                            <table className="grafico_registros" >
                                                <thead>
                                                    <tr>
                                                        <th style={{ textAlign: 'right' }}></th>
                                                        <th style={{ width: '180px', textAlign: 'right' }} >{EVOLUCION_COMPRA_ANYO.ANYO - 1}</th>
                                                        <th style={{ width: '180px', textAlign: 'right' }} >{EVOLUCION_COMPRA_ANYO.ANYO}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        obtenerEstadisticaEjercicioGrafico(EVOLUCION_COMPRAS, false, [EVOLUCION_COMPRA_ANYO.ANYO - 1, EVOLUCION_COMPRA_ANYO.ANYO]).map((registro, i) =>
                                                            <tr key={i} >
                                                                <td className="txt_inicial_tabla" style={{ textAlign: 'right' }}>{traducirPagina(convertirCodigoAMeses(registro.MES_NO)).toUpperCase()}</td>
                                                                {ordenarRegistroTabla(Object.keys(registro)).map((item, i) =>
                                                                    <td className="margen_unico" style={{ textAlign: 'right' }}>{registro[item]}</td>
                                                                )}
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        :
                                        <LineChart
                                            width={ANCHO}
                                            height={ALTO}
                                            data={obtenerEstadisticaEjercicioGrafico(EVOLUCION_COMPRAS, true, [EVOLUCION_COMPRA_ANYO.ANYO - 1, EVOLUCION_COMPRA_ANYO.ANYO])}
                                            margin={{
                                                top: 2,
                                                right: 2,
                                                left: 20,
                                                bottom: 2
                                            }}
                                        >
                                            <CartesianGrid strokeDasharray="8 8" />
                                            <XAxis dataKey="MES" />
                                            <YAxis />
                                            <Tooltip />
                                            {/*  <Legend height={2}  />*/}


                                            {registroKeyGrafico.map((registro) =>
                                                registroKeyGrafico.filter((item) => item.NOMBRE === registro.NOMBRE && item.ACTIVO).length > 0 ? <Line type="monotone" dataKey={registro.NOMBRE} stroke={registro.COLOR} /> : null
                                            )}
                                        </LineChart>



                                    :
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                            }

                        </div>
                        <div className="footer_graficos">
                            <div>
                                <button style={{ backgroundColor: 'var( --azul-claro-serca)', color: '#fff' }} onClick={() => { initFilter.MOSTRAR_TABLA = true; setInitFilter({ ...initFilter }) }}>{traducirPagina("Tabla")}</button>

                                <button onClick={() => { initFilter.MOSTRAR_TABLA = false; setInitFilter({ ...initFilter }) }}>{traducirPagina("Grafico")}</button>
                            </div>
                            <div>
                                <CPAnyosPeriodo ID={9} MES_SELECCIONADO={periodoMes} ANYO_SELECCIONADO={anyoActual} ></CPAnyosPeriodo>
                            </div>
                        </div>
                    </div>



                </div>


                <div className="container_graficos3">
                    <div className={`graficos3_child1 ${REDES_GRUPO !== null && REDES_GRUPO.length > 0 ? "desactivar_loader" : "activar_loader"}`}>
                        <div className="titulo_card"> Redes grupo </div>

                        <div className="body_grafico container_servicio">
                            {
                                REDES_GRUPO === null ?
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '10vh', width: '100%' }}> <h3 style={{ margin: 0 }}>{traducirPagina("Sin_resultados")}</h3> </div>
                                    :
                                    REDES_GRUPO.length > 0 ?
                                        REDES_GRUPO.map((registro, i) =>

                                            <div className={REDES_GRUPO.length - 1 > i ? `servicio_separador` : ""} >
                                                <div className="titulo_servicio">{registro.NOMBRE}</div>

                                                <div className="body_servicio">
                                                    <div className="servicio_info">Grupo <span>{registro.TALLERES_GRUPO}	</span></div>
                                                    <div className="servicio_info">Mis talleres <span>{registro.TALLERES_SOCIO}</span></div>
                                                </div>


                                                <div className="center_porcentaje">
                                                    <Progress type="circle" percent={registro.CIENTO_TOTAL.replace(",", ".")} strokeColor='var(--azul-claro-serca)' width={100} />
                                                </div>
                                            </div>


                                        )


                                        :
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '10vh', width: '100%' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                            }
                        </div>

                        <div className="footer_graficos">
                            <div>
                                <button>{traducirPagina("Evolucion")}</button>
                            </div>
                            <div>
                                <CPAnyosPeriodo ID={6} MES_SELECCIONADO={periodoMes} ANYO_SELECCIONADO={anyoActual} ></CPAnyosPeriodo>
                            </div>
                        </div>
                    </div>

                    <div className={`graficos3_child2 ${MATRICULAS !== null && Object.keys(MATRICULAS).length > 0 ? "desactivar_loader" : "activar_loader"}`} style={{ minHeight: '260px' }} >

                        <div className="titulo_card">
                            Matrículas
                        </div>

                        <div className="body_grafico" style={{ display: 'block' }}>

                            {
                                MATRICULAS === null ?
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '10vh', width: '100%' }}> <h3 style={{ margin: 0 }}>{traducirPagina("Sin_resultados")}</h3> </div>
                                    :
                                    Object.keys(MATRICULAS).length > 0 ?
                                        <>
                                            <div className="total_matricula">
                                                <small>TOTALES</small>
                                                <h3 style={{ color: 'var(--azul-claro-serca)', textAlign: 'right' }}>{MATRICULAS.TOTAL_MATRICULAS}</h3>
                                            </div>
                                            <table className="grafico_registros ">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: "140px" }} ></th>
                                                        <th ></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ textAlign: 'left' }} className="txt_inicial_tabla">{"GRUPO"}</td>
                                                        <td style={{ textAlign: 'left' }}>{MATRICULAS.TOTAL_CONSULTAS_GRUPO}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: 'left' }} className="txt_inicial_tabla">{"MIS CONSULTAS"}</td>
                                                        <td style={{ textAlign: 'left' }}>{MATRICULAS.NUMERO_TOTAL_CONSULTAS_MATRICULAS_SOCIO}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: 'left' }} className="txt_inicial_tabla">{"NUEVAS"}</td>
                                                        <td style={{ textAlign: 'left' }}>{`${MATRICULAS.NUMERO_TOTAL_CONSULTAS_MATRICULAS_SOCIO_COBRADAS} (${MATRICULAS.CIENTO_COBRADAS}%)`}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: 'left' }} className="txt_inicial_tabla">{"REPETIDAS"}</td>
                                                        <td style={{ textAlign: 'left' }}>{`${MATRICULAS.NUMERO_TOTAL_CONSULTAS_MATRICULAS_SOCIO_REPETIDAS} (${MATRICULAS.CIENTO_REPETIDAS}%)`}</td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </>

                                        :
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '10vh', width: '100%' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                            }

                        </div>

                        <div className="footer_graficos">
                            <div>
                                <button onClick={() => {
                                    if (initFilter.ID_SOCIO === null) {
                                        MSGERROR(traducirPagina("Seleccione_socio"))
                                    } else {
                                        setAbriFichaMatricula(true)
                                    }

                                }}>{traducirPagina("Detalle")}</button>
                            </div>
                            <div>
                                <CPAnyosPeriodo ID={7} MES_SELECCIONADO={periodoMes} ANYO_SELECCIONADO={anyoActual} ></CPAnyosPeriodo>
                            </div>
                        </div>
                    </div>

                    <div className={`graficos3_child3 ${VENTAS !== null && VENTAS.length > 0 ? "desactivar_loader" : "activar_loader"}`}>
                        <div className="titulo_card"> Ventas online </div>

                        <div className="body_grafico">

                            {VENTAS === null ?
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '10vh', width: '100%' }}> <h3 style={{ margin: 0 }}>{traducirPagina("Sin_resultados")}</h3> </div>
                                :
                                VENTAS.length > 0 ?
                                    <table className="grafico_registros" style={VENTAS.length <= 2 ? { maxHeight: '120px' } : {}}>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th style={{ width: "120px" }} >{VENTAS_ANYO.ANYO - 1}</th>
                                                <th style={{ width: "120px" }} className="margen_unico">{VENTAS_ANYO.ANYO}</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                VENTAS.map((registro) =>
                                                    <tr>
                                                        <td className="txt_inicial_tabla">{registro.TRIMESTRE}</td>
                                                        <td>{registro.IMPORTE_ANTERIOR}</td>
                                                        <td className="margen_unico">{registro.IMPORTE}</td>
                                                    </tr>
                                                )
                                            }

                                        </tbody>
                                    </table>
                                    :
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '10vh', width: '100%' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                            }
                        </div>

                        <div className="footer_graficos">
                            <div>
                                <button onClick={() => {
                                    setAbrirDesgloseVentas(true)
                                }}>{traducirPagina("Desglose")}</button>
                            </div>
                            <div>
                                <CPAnyosPeriodo ID={8} MES_SELECCIONADO={periodoMes} ANYO_SELECCIONADO={anyoActual} ></CPAnyosPeriodo>
                            </div>

                        </div>
                    </div>

                </div>



            </div>

            {
                abrirDesgloseVentas &&
                <FichaVentaOnline
                    title={"VENTAS ONLINE"}
                    ABRIR_FICHA={abrirDesgloseVentas}
                    CERRAR_FICHA={setAbrirDesgloseVentas}
                    DATOS={initFilter}
                >

                </FichaVentaOnline>
            }

            {
                abriFichaMatricula && (
                    <FichaDetalleMatriculaSocio
                        titulo={"DETALLE DE LAS MATRÍCULAS"}
                        abrirFicha={abriFichaMatricula}
                        cerrarFicha={setAbriFichaMatricula}
                        MES_INI={obtenerMesPeriodo(initFilter.MATRICULAS_ANYO.MES).INICIO}
                        MES_FIN={obtenerMesPeriodo(initFilter.MATRICULAS_ANYO.MES).FIN}
                        ANYO={initFilter.MATRICULAS_ANYO.ANYO}
                        ID_SOCIO={initFilter.ID_SOCIO}
                    >
                    </FichaDetalleMatriculaSocio>
                )
            }


        </>
    );
}


Home.propTypes = {
    EVENTO_MENU: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
    };
}

export default connect(mapStateToProps)(Home);








